module.exports = __webpack_public_path__ + "img/1-3.b83e3e9c.png";